import { CategoryPageSectionType } from '../../types/TemplateConfiguration'

enum RegisteredTests {
  DUMMY_EXPERIMENT = 'DUMMY_EXPERIMENT'
}

type TestRegistry = {
  [testKey in RegisteredTests | string]: {
    [variationKey: string]: {
      sectionType?: CategoryPageSectionType
      position?: number
      component: (props: any) => JSX.Element | null
      mcIds?: string[]
      locales?: string[]
      isPageSection?: boolean
      sectionIdsToRemove?: Record<string, string[]>
    }[]
  }
}

const testRegistry: TestRegistry = {
  [RegisteredTests.DUMMY_EXPERIMENT]: {
    dummyVarA: [
      {
        sectionType: 'page header',
        position: 1,
        component: () => null,
        mcIds: [''],
        locales: [''],
        sectionIdsToRemove: {
          '': ['']
        }
      }
    ]
  }
}

const getRegisteredTest = (
  experimentKey: string,
  variationKey: string,
  metadata?: {
    newSectionPosition: number | undefined
  }
) => {
  if ((Object.values(RegisteredTests) as string[]).includes(experimentKey)) {
    const testVariations = testRegistry[experimentKey][variationKey]
    if (testVariations) {
      return testVariations.map((variation) => ({
        ...variation,
        position: metadata?.newSectionPosition ?? variation.position
      }))
    }
  }
}

const getSupportedLocales = (experimentKey: string, variationKey: string) => {
  if ((Object.values(RegisteredTests) as string[]).includes(experimentKey)) {
    return testRegistry[experimentKey][variationKey][0].locales?.map((locale) =>
      locale.toLowerCase()
    )
  }
}

const getSupportedMechandisingId = (experimentKey: string, variationKey: string) => {
  if ((Object.values(RegisteredTests) as string[]).includes(experimentKey)) {
    return testRegistry[experimentKey][variationKey][0].mcIds
  }
}

export { RegisteredTests, getRegisteredTest, getSupportedLocales, getSupportedMechandisingId }
